import React, { Component } from 'react';
import { Form, Control } from 'react-redux-form';
import { Link } from 'react-router-dom';
import { debounce } from 'lodash';

import validators from '../../../helpers/validators';
import * as endpoints from '../../../helpers/endpoints';
import apiRequest from '../../../helpers/apiRequest';

import Textfield from '../../ui/text-field';
import AutoSuggest from '../../ui/auto-suggest';
import Modal from '../../ui/modal';
import PRModal from '../../ui/modal-pr-confirm';

import validObj from '../../../helpers/validateObj';
import crossFormValidation from '../../../helpers/crossFormValidation';

class VendorInformation extends Component {
    state = {
        vendorInfo: [],
        selectedVendor: {},
        showAutoSuggest: false
    };

    handleSubmit = e => {
        if (this.props.userAction === 'addVendor') {
            if (this.props.eventId) {
                if (e.vendorForm.id) {
                    this.props.updateAndAssignVendor(e.vendorForm);
                } else {
                    this.props.createAndAssignVendor(e.vendorForm);
                }
            } else if (e.vendorForm.id) {
                this.props.updateAndStoreVendor(e.vendorForm);
            } else {
                this.props.createAndStoreVendor(e.vendorForm);
            }
            this.props.vendorInformationLoad({});
        } else {
            const formsValidObj = crossFormValidation(e);
            if (formsValidObj.formsValid) {
                const formObj = validObj(e);
                switch (this.props.userAction) {
                    case 'save':
                        if (formObj.id) {
                            this.props.updateEvent(formObj);
                        } else {
                            this.props.createEvent(formObj);
                        }
                        break;
                    case 'submit':
                        let canSubmit = true;
                        if (this.props.onsiteActivations > 0) {
                            if (
                                this.props.onSiteAddDates &&
                                this.props.onSiteAddDates.length === 0
                            ) {
                                canSubmit = false;
                                this.props.setEventErrorMessage(
                                    'Please add at least one on-site date.'
                                );
                            }
                        }
                        if (canSubmit) {
                            if (formObj.cost > 0 && formObj.contract === '0') {
                                if (this.props.prComplete) {
                                    if (formObj.id) {
                                        this.props.updateAndSubmitEvent(
                                            formObj
                                        );
                                    } else {
                                        this.props.createAndSubmitEvent(
                                            formObj
                                        );
                                    }
                                } else {
                                    this.props.showPRModal();
                                }
                            } else {
                                if (formObj.id) {
                                    this.props.updateAndSubmitEvent(formObj);
                                } else {
                                    this.props.createAndSubmitEvent(formObj);
                                }
                            }
                        }
                        break;
                    case 'reject':
                        if (formObj.vendorForm) {
                            delete formObj.vendorForm;
                        }
                        this.props.rejectEvent(formObj);
                        break;
                    case 'approve':
                        if (formObj.vendorForm) {
                            delete formObj.vendorForm;
                        }
                        if (this.props.approvers.length === 0) {
                            delete formObj.approverId;
                        }
                        if (this.props.userInfo.Billet.location === 'MCRC') {
                            if (this.props.mcrcUploadedFile) {
                                this.props.updateAndApproveEvent(formObj);
                            } else {
                                this.props.setEventErrorMessage(
                                    'Please upload a signature of approval document.'
                                );
                            }
                        } else if (this.props.eventApproveReject) {
                            if (
                                this.props.userInfo.Billet.name === 'MPA' ||
                                this.props.userInfo.Billet.name === 'MAC'
                            ) {
                                if (this.props.recommend) {
                                    if (this.props.recommend.value === '0') {
                                        if (this.props.recommendReason) {
                                            this.props.updateAndApproveEvent(
                                                formObj
                                            );
                                        } else {
                                            this.props.setEventErrorMessage(
                                                "Please provide a reason you don't recommend this event."
                                            );
                                        }
                                    } else {
                                        this.props.updateAndApproveEvent(
                                            formObj
                                        );
                                    }
                                } else {
                                    this.props.setEventErrorMessage(
                                        'Please provide a recommendation.'
                                    );
                                }
                            } else {
                                this.props.approveEvent(formObj);
                            }
                        } else {
                            this.props.approveEvent(formObj);
                        }
                        break;
                    case 'request':
                        this.props.requestInfoEvent(formObj);
                        break;
                    case 'update':
                        this.props.updateEvent(formObj);
                        break;
                    case 'hideModal':
                        this.props.hidePRModal();
                        break;
                    default:
                        console.log(this.props.userAction);
                }
            } else if (this.props.userAction === 'save') {
                if (e.name && e.sDate && e.startTime) {
                    const formObj = validObj(e);

                    if (e.id) {
                        this.props.updateEvent(formObj);
                    } else {
                        this.props.createEvent(formObj);
                    }
                }
            } else {
                this.props.setInvalidTabs(formsValidObj);
            }
        }
    };

    handleSubmitFailed = e => {
        const formsValidObj = crossFormValidation(e);
        if (formsValidObj.formsValid) {
            const formsValidObj = crossFormValidation(e);
            this.props.setInvalidTabs(formsValidObj);
            if (formsValidObj.formsValid) {
                const formObj = validObj(e);
                const validVendors = formObj.vendorsInformation;

                switch (this.props.userAction) {
                    case 'save':
                        if (formObj.id) {
                            this.props.updateEvent(formObj);
                        } else {
                            this.props.createEvent(formObj);
                        }
                        break;
                    case 'submit':
                        let canSubmit = true;
                        if (this.props.onsiteActivations > 0) {
                            if (this.props.onSiteAddDates.length === 0) {
                                canSubmit = false;
                                this.props.setEventErrorMessage(
                                    'Please add at least one on-site date.'
                                );
                            }
                        }
                        if (canSubmit) {
                            if (formObj.cost > 0 && formObj.contract === '0') {
                                if (this.props.prComplete) {
                                    if (formObj.id) {
                                        this.props.updateAndSubmitEvent(
                                            formObj,
                                            validVendors
                                        );
                                    } else if (formObj.approverId) {
                                        this.props.createAndSubmitEvent(
                                            formObj,
                                            validVendors
                                        );
                                    }
                                } else {
                                    this.props.showPRModal();
                                }
                            } else {
                                if (formObj.id) {
                                    this.props.updateAndSubmitEvent(
                                        formObj,
                                        validVendors
                                    );
                                } else if (formObj.approverId) {
                                    this.props.createAndSubmitEvent(
                                        formObj,
                                        validVendors
                                    );
                                }
                            }
                        }
                        break;
                    case 'reject':
                        if (formObj.vendorForm) {
                            delete formObj.vendorForm;
                        }
                        this.props.rejectEvent(formObj);
                        break;
                    case 'approve':
                        if (formObj.vendorForm) {
                            delete formObj.vendorForm;
                        }
                        if (this.props.approvers.length === 0) {
                            delete formObj.approverId;
                        }
                        if (this.props.userInfo.Billet.location === 'MCRC') {
                            if (this.props.mcrcUploadedFile) {
                                this.props.approveEvent(formObj);
                            } else {
                                this.props.setEventErrorMessage(
                                    'Please upload a signature of approval document.'
                                );
                            }
                        } else if (this.props.eventApproveReject) {
                            if (
                                this.props.userInfo.Billet.name === 'MPA' ||
                                this.props.userInfo.Billet.name === 'MAC'
                            ) {
                                if (this.props.recommend) {
                                    if (this.props.recommend.value === '0') {
                                        if (this.props.recommendReason) {
                                            this.props.updateAndApproveEvent(
                                                formObj
                                            );
                                        } else {
                                            this.props.setEventErrorMessage(
                                                "Please provide a reason you don't recommend this event."
                                            );
                                        }
                                    } else {
                                        this.props.updateAndApproveEvent(
                                            formObj
                                        );
                                    }
                                } else {
                                    this.props.setEventErrorMessage(
                                        'Please provide a recommendation.'
                                    );
                                }
                            } else {
                                this.props.approveEvent(formObj);
                            }
                        } else {
                            this.props.approveEvent(formObj);
                        }
                        break;
                    case 'request':
                        this.props.requestInfoEvent(formObj);
                        break;
                    case 'update':
                        this.props.updateEvent(formObj);
                        break;
                    case 'hideModal':
                        this.props.hidePRModal();
                        break;
                    default:
                        console.log(this.props.userAction);
                }
            }
        } else if (this.props.userAction === 'save') {
            // const vendorItems = e.vendorsInformation;

            if (e.name.value && e.sDate.value && e.startTime.value) {
                const mappedValues = {};
                Object.keys(e).forEach(item => {
                    if (e[item].value) {
                        mappedValues[item] = e[item].value;
                    }
                    if (item === 'vendorsInformation') {
                        const vendors = e[item];
                        mappedValues[item] = [];
                        let newArr = [];
                        for (let val in vendors) {
                            if (val !== '$form') {
                                newArr.push(vendors[val]);
                            }
                        }
                        for (let i = 0; i < newArr.length; i++) {
                            let copyObj = newArr[i];
                            let newObj = {};
                            Object.keys(copyObj).forEach(item => {
                                newObj[item] = copyObj[item].value;
                            });
                            mappedValues[item].push(newObj);
                        }
                    }
                });

                const formObj = validObj(mappedValues);
                const validVendors = mappedValues.vendorsInformation;
                if (e.id && e.id.value) {
                    this.props.updateEvent(formObj, validVendors);
                } else {
                    this.props.createEvent(formObj, validVendors);
                }
            }
        } else if (this.props.userAction === 'reject') {
            const mappedValues = {};
            Object.keys(e).forEach(item => {
                if (e[item].value) {
                    mappedValues[item] = e[item].value;
                }
                if (item === 'vendorsInformation') {
                    const vendors = e[item];
                    mappedValues[item] = [];
                    let newArr = [];
                    for (let val in vendors) {
                        if (val !== '$form') {
                            newArr.push(vendors[val]);
                        }
                    }
                    for (let i = 0; i < newArr.length; i++) {
                        let copyObj = newArr[i];
                        let newObj = {};
                        Object.keys(copyObj).forEach(item => {
                            newObj[item] = copyObj[item].value;
                        });
                        mappedValues[item].push(newObj);
                    }
                }
            });
            const formObj = validObj(mappedValues);
            this.props.rejectEvent(formObj);
        } else {
            this.props.setInvalidTabs(formsValidObj);
        }
    };

    getVendors = debounce(e => {
        if (e.target.value.length > 3) {
            apiRequest(
                `${endpoints.VENDOR_SEARCH_PATH}${e.target.value}`,
                this.props.jwtToken
            ).then(results => {
                let vendorInfo = results.data;
                vendorInfo = vendorInfo.slice(0, 9);
                this.setState({ vendorInfo });
            });
            this.setState({ showAutoSuggest: true });
        } else if (e.target.value.length < 1) {
            this.setState({ vendorInfo: [] });
            this.setState({ showAutoSuggest: false });
        }
    }, 750);

    setVendor = e => {
        const target = e.target;
        const index = target.getAttribute('data-index');
        const vendorObject = this.state.vendorInfo[index];
        this.setState({ selectedVendor: vendorObject });
        this.props.vendorInformationLoad(vendorObject);
        this.setState({ showAutoSuggest: false });
    };

    displayVendorInfo = index => {
        const vendorItem = this.props.vendorInformationData[index];
        this.props.vendorInformationLoad({});
        this.props.vendorInformationLoad(vendorItem);
        this.setState({
            showAutoSuggest: false
        });
    };

    removeVendor = index => {
        this.props.vendorInformationRemove(index);
    };

    render() {
        const required = validators.required();
        const showDropdown = this.state.showAutoSuggest;
        let dropdown = null;

        if (showDropdown) {
            dropdown = (
                <AutoSuggest
                    onClick={this.setVendor}
                    listValues={this.state.vendorInfo}
                />
            );
        }

        return (
            <Form
                className="form"
                model="event"
                encType="multipart/form-data"
                onSubmit={this.handleSubmit}
                onSubmitFailed={this.handleSubmitFailed}
            >
                <div className="tab__title">Vendor Information</div>
                <div className="first-col">
                    <div className="form__section-title">Add New Vendor</div>

                    <Textfield
                        model="event.vendorForm.name"
                        value={this.state.selectedVendor.name}
                        isRequired
                        title="Vendor Name"
                        validators={{ required }}
                        messages={{ required: required.message }}
                        onChange={this.getVendors}
                        disabled={!this.props.canEdit}
                    />

                    {dropdown}

                    <Textfield
                        model="event.vendorForm.contactName"
                        value={this.state.selectedVendor.contactName}
                        isRequired
                        title="Contact Name"
                        validators={{ required }}
                        messages={{ required: required.message }}
                        disabled={!this.props.canEdit}
                    />

                    <Textfield
                        model="event.vendorForm.address"
                        value={this.state.selectedVendor.address}
                        title="Street Address"
                        disabled={!this.props.canEdit}
                    />

                    <Textfield
                        model="event.vendorForm.building"
                        value={this.state.selectedVendor.building}
                        title="Building"
                        disabled={!this.props.canEdit}
                    />

                    <Textfield
                        type="email"
                        model="event.vendorForm.email"
                        value={this.state.selectedVendor.email}
                        title="Email"
                        disabled={!this.props.canEdit}
                    />

                    <Textfield
                        type="tel"
                        model="event.vendorForm.phone"
                        value={this.state.selectedVendor.phone}
                        title="Phone"
                        maxLength="10"
                        disabled={!this.props.canEdit}
                    />

                    <Textfield
                        type="tel"
                        model="event.vendorForm.mobile"
                        value={this.state.selectedVendor.mobile}
                        title="Mobile"
                        maxLength="10"
                        disabled={!this.props.canEdit}
                    />

                    <Textfield
                        type="number"
                        model="event.vendorForm.fax"
                        value={this.state.selectedVendor.fax}
                        title="Fax"
                        disabled={!this.props.canEdit}
                    />

                    <Textfield
                        model="event.vendorForm.url"
                        title="URL"
                        value={this.state.selectedVendor.url}
                        disabled={!this.props.canEdit}
                    />

                    <Textfield
                        type="number"
                        model="event.vendorForm.cagecode"
                        title="Cage Code"
                        value={this.state.selectedVendor.cagecode}
                        disabled={!this.props.canEdit}
                    />

                    {this.props.canEdit ? (
                        <Control.reset
                            className="btn btn--clear"
                            model="event"
                            type="reset"
                        >
                            Clear
                        </Control.reset>
                    ) : null}
                    {this.props.canEdit ? (
                        <button
                            type="submit"
                            className="btn btn--add"
                            onClick={() => {
                                this.props.setEventUserAction('addVendor');
                            }}
                        >
                            Add
                        </button>
                    ) : null}
                </div>

                <div className="second-col">
                    <div className="form__row">
                        <div className="form__row-title">List of Vendors</div>

                        <ul className="ordered-list">
                            {this.props.vendorInformationData.map(
                                (item, index) => (
                                    <li
                                        className="ordered-list__item"
                                        key={index}
                                        data-index={index}
                                    >
                                        {this.props.purchaseRequestId ? (
                                            <span
                                                className={`event__download-container testing button ${
                                                    this.props.type
                                                }`}
                                            >
                                                <a
                                                    className="btn btn--secondary event__download-item event__purchaseRequest"
                                                    target="_blank"
                                                    href={`https://${
                                                        endpoints.envCheck
                                                    }ems.marines.com/purchaserequest/dd1535?id=${
                                                        this.props
                                                            .purchaseRequestId
                                                    }&vendorId=${item.id}&t=${
                                                        this.props.jwtToken
                                                    }`}
                                                >
                                                    Download DD1535
                                                </a>
                                            </span>
                                        ) : null}

                                        {!this.props.canSaveSubmit ? (
                                            <Link
                                                to="#"
                                                onClick={() =>
                                                    this.displayVendorInfo(
                                                        index
                                                    )
                                                }
                                            >
                                                <span className="ordered-list__title">
                                                    {item.name}
                                                </span>
                                            </Link>
                                        ) : (
                                            <span className="ordered-list__title">
                                                {item.name}
                                            </span>
                                        )}

                                        {this.props.canEdit ? (
                                            <span
                                                className="event__remove-item"
                                                onClick={() =>
                                                    this.removeVendor(index)
                                                }
                                            >
                                                <svg className="icon icon-close">
                                                    <use xlinkHref="#icon-close" />
                                                </svg>
                                            </span>
                                        ) : null}
                                    </li>
                                )
                            )}
                        </ul>
                    </div>
                </div>

                <Control.text
                    model="event.hidden"
                    type="hidden"
                    value="eventId"
                    disabled={!this.props.canEdit}
                />

                <div className="form__actions form__actions--global">
                    {this.props.canSaveSubmit ? (
                        <Control.button
                            className="btn btn--secondary"
                            type="submit"
                            model="event.userActionTaken"
                            value="save"
                            onClick={() => {
                                this.props.setEventUserAction('save');
                            }}
                        >
                            Save
                        </Control.button>
                    ) : null}
                    {this.props.canSaveSubmit ? (
                        <Control.button
                            className="btn btn--submit"
                            type="submit"
                            model="event.userActionTaken"
                            value="submit"
                            onClick={() => {
                                this.props.setEventUserAction('submit');
                            }}
                        >
                            Submit
                        </Control.button>
                    ) : null}
                    {this.props.eventApproveReject ? (
                        <Modal
                            title="Reject Event"
                            classes="btn btn--secondary"
                            closeButtonCopy="Cancel"
                            toggleAction={this.props.rejectModalActive}
                            toggleModal={this.props.toggleRejectModal}
                            submitAction={this.props.setEventUserAction}
                            submitValue={'reject'}
                        >
                            <div className="form__section-title">
                                Reject Event
                            </div>
                            <Textfield
                                model="event.rejectComments"
                                title="Rejection Comments"
                                maxLength="250"
                            />
                        </Modal>
                    ) : null}
                    {this.props.eventApproveReject ? (
                        <Modal
                            title="Approve"
                            classes="btn btn--submit"
                            closeButtonCopy="Cancel"
                            toggleAction={this.props.approveModalActive}
                            toggleModal={this.props.toggleApproveModal}
                            submitAction={this.props.setEventUserAction}
                            submitValue={'approve'}
                        >
                            <div className="form__section-title">
                                Approve Event
                            </div>
                        </Modal>
                    ) : null}
                    {this.props.eventApproveReject ? (
                        <Modal
                            title="Returned for Edit"
                            classes="btn btn--secondary"
                            closeButtonCopy="Cancel"
                            toggleAction={this.props.requestModalActive}
                            toggleModal={this.props.toggleRequestModal}
                            submitAction={this.props.setEventUserAction}
                            submitValue={'request'}
                        >
                            <div className="form__section-title">
                                Returned for Edit
                            </div>
                            <Textfield
                                model="event.rejectComments"
                                title="Comments"
                                maxLength="250"
                            />
                        </Modal>
                    ) : null}
                    <PRModal
                        submitAction={this.props.setEventUserAction}
                        setPRComplete={this.props.setPRComplete}
                        toggleAction={this.props.prModalActive}
                        toggleModal={this.props.hidePRModal}
                    >
                        <div className="form__section-title">
                            Submit without a purchase request?
                        </div>
                        <p>
                            Please confirm you would like to submit this event
                            without a purchase request.
                        </p>
                    </PRModal>
                </div>
            </Form>
        );
    }
}

export default VendorInformation;



// WEBPACK FOOTER //
// ./src/components/event/vendor-information/index.js